<script setup lang="ts">
import { Info } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const props = withDefaults(defineProps<{
    description: string;
    label?: string;
}>(), {
    label: 'More information',
});
</script>

<template>
    <TooltipProvider :delay-duration="250">
        <Tooltip>
            <TooltipTrigger as-child>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon-sm"
                    class="size-6 shrink-0 rounded-full text-muted-foreground/70 hover:bg-muted hover:text-foreground"
                    :aria-label="props.label"
                >
                    <Info class="size-3.5" />
                </Button>
            </TooltipTrigger>
            <TooltipContent side="top" class="max-w-72 text-pretty leading-5">
                {{ description }}
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
</template>
